import Splide from '@splidejs/splide';

const EL = '.js-coursescard-carousel';

document.querySelectorAll('.js-card-carousel').forEach((carousel) => {
  const slider = new Splide(carousel, {
    arrows: false,
    pagination: false,
    gap: 40,
    fixedWidth: '566px',
    breakpoints: {
      1366: {

      },
      1024: {
        fixedWidth: '280px',
        gap: 20,
      },
      767: {
        pagination: true,
      },
    },
  });

  slider.mount();

  const prevButton = carousel.querySelector('.splide__nav--prev');
  const nextButton = carousel.querySelector('.splide__nav--next');
  const counter = carousel.parentElement.querySelector('.card-carousel__number');


  const updateControls = () => {
    const currentSlide = slider.index + 1;
    const totalSlides = slider.length;
    const isLoop = slider.options.type === 'loop';

    if (counter) counter.textContent = `${currentSlide} / ${totalSlides}`;

    if (!isLoop) {
      if (prevButton) prevButton.disabled = slider.index === 0;
      if (nextButton) nextButton.disabled = slider.index === totalSlides - 1;
    } else {
      if (prevButton) prevButton.disabled = false;
      if (nextButton) nextButton.disabled = false;
    }
  };


  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => slider.go('<'));
    nextButton.addEventListener('click', () => slider.go('>'));
  }

  slider.on('moved', updateControls);

  updateControls();
});
